
export const ActionEnum = {
  ADD: 'ADD',
  EDIT: 'EDIT',
  PREVIEW: 'PREVIEW',
  REMOVE: 'REMOVE',
};
